import Image from "next/image";

type Props = {
  hint?: string;
  className?: string;
};

function renderHintText(text: string): React.ReactNode[] {
  return text
    .split("**")
    .map((segment, i) =>
      i % 2 === 1 ? (
        <strong key={i}>{segment}</strong>
      ) : (
        <span key={i}>{segment}</span>
      ),
    );
}

export default function HintCard({ hint, className }: Props) {
  if (!hint) return null;

  return (
    <div
      className={`rounded-2xl bg-white p-5 ${className ?? ""}`.trim()}
      data-testid="practice-hint-card"
    >
      <div className="flex items-center gap-2 mb-3">
        <Image
          src="/images/mentai-senpai_03_good01.png"
          alt="めんたい先輩"
          width={64}
          height={64}
          loading="lazy"
        />
        <h3 className="text-base font-bold">回答を良くするヒント</h3>
      </div>
      <ul className="list-disc pl-5 space-y-1.5">
        <li className="text-sm leading-relaxed">{renderHintText(hint)}</li>
      </ul>
    </div>
  );
}
